import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        component: () => import('@/views/user/login.vue'),
        name: 'user-login',
        meta: {
            title: '用户登录'
        }
    },
    {
        path: '/loginout',
        component: () => import('@/views/user/loginout.vue'),
        name: 'user-loginout',
    },
    {
        path: "/register",
        component: () => import('@/views/user/register.vue'),
        name: 'user-register',
        meta: {
            title: '用户注册 '
        }
    },
    {
        path: '/',
        name: 'Layout',
        redirect: "/",
        component: () => import('@/layout/index.vue'),
        children: [
            {
                path: '/404',
                component: () => import('@/views/error/404.vue'),
                name: 'error-404',
                meta: {
                    title: '页面不存在'
                }
            },
            {
                path: "/user/repass",
                component: () => import('@/views/user/repass.vue'),
                name: 'user-repass',
                meta: {
                    title: '找回密码'
                }
            },
            {
                path: 'user',
                component: () => import('@/views/user/index.vue'),
                name: 'user-index',
                redirect: "/user/general",
                children: [
                    {
                        path: 'integral',
                        component: () => import('@/views/user/component/integral.vue'),
                        name: 'user-integral',
                        meta: {
                            title: '我的积分'
                        }
                    },
                    {
                        path: 'general',
                        component: () => import('@/views/user/component/general.vue'),
                        name: 'user-general',
                        meta: {
                            title: '基本资料'
                        }
                    },
                    {
                        path: 'password',
                        component: () => import('@/views/user/component/password.vue'),
                        name: 'user-password',
                        meta: {
                            title: '修改密码'
                        }
                    },
                    {
                        path: 'favorite',
                        component: () => import('@/views/user/component/favorite.vue'),
                        name: 'user-favorite',
                        meta: {
                            title: '我的收藏'
                        }
                    },
                    {
                        path: 'obtain/record',
                        component: () => import('@/views/user/component/record/obtain'),
                        name: 'user-obtain-record',
                        meta: {
                            title: '修改密码'
                        }
                    },
                ]
            },
            {
                path: '/',
                component: () => import('@/views/index/index.vue'),
                name: 'index',
                props: true,
            },
            {
                path: '/demand',
                component: () => import('@/views/demand/index.vue'),
                name: 'article-demand',
                meta: {
                    title: '反馈建议'
                }
            },
            {
                path: '/special',
                component: () => import('@/views/special/index.vue'),
                name: 'qjgame-special',
                meta: {
                    title: '专题列表'
                }
            },
            {
                path: '/special/:id',
                component: () => import('@/views/special/detail.vue'),
                name: 'qjgame-special-detail',
                meta: {
                    title: '专题详情'
                }
            },
            {
                path: '/detail/:id',
                component: () => import('@/views/article/detail.vue'),
                name: 'article-detail',
                props: true,
            },
            {
                path: '/download',
                component: () => import('@/views/article/download.vue'),
                name: 'article-download',
                props: true,
            },
            {
                path: ':first',
                component: () => import('@/views/article/list.vue'),
                name: 'article-list-1',
                props: true,
            },
            {
                path: ':first/:second',
                component: () => import('@/views/article/list.vue'),
                name: 'article-list-2',
                props: true,
            },
        ]
    },
    {
        path: '*',
        redirect: "404"
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title){
        document.title = to.meta.title+" - QJGAME"
    }else {
        document.title = "个人分享网站 - QJGAME"
    }
    // 让页面回到顶部
    document.documentElement.scrollTop = 0;

    if(to.path === '/login'){
        let referrer = '';
        if (from.path === '/loginout' || from.path === '/login' || from.path === '/register'){
            referrer = "/"
        }else {
            referrer = from.path;
        }
        //储存来源路由
        sessionStorage.setItem('referrer',referrer)
    }

    if (to.path.includes("detail")){
        store.commit("updateTocFlag",true)
    }else {
        store.commit("updateTocFlag",false)
    }

    next();
});

export default router
